import { DateTime } from 'luxon';

import { BilletInfo } from '@portal/models/module';

import { formatBilletInput } from './format';

/**
 * Class representing a billet
 */
export default class Billet {
  billet: BilletInfo;

  /**
   * @param {BilletInfo} billet Billet info
   */
  constructor(billet: BilletInfo) {
    this.billet = billet;
    this.calcTotal();
  }

  /**
   * Calculate with disocunts and additions
   *
   * @returns {number} Total value after all calcs
   */
  calcTotal = (): number => {
    const {
      totalAmount,
      discount = 0,
      fine = 0,
      interest = 0,
      deductions = 0,
    } = this.billet;
    if (this.billet.consolidatedAmount) {
      return this.billet.consolidatedAmount;
    }
    if (totalAmount > 0) {
      const totalDiscounts = discount + deductions;
      const totalAddition = fine + interest;
      const total = totalAmount - totalDiscounts + totalAddition;

      return total;
    }

    return 0;
  };

  /**
   * @returns {string} Billet's due date or today, if undefined
   */
  getDueDate = (): string => {
    const { dueDate } = this.billet;
    if (dueDate) {
      return dueDate;
    }

    return DateTime.now().toISODate();
  };

  /**
   * @returns {boolean} true if is beneficiary billet and false if it's a service one
   */
  isBillet = (): boolean => this.billet.barcode.indexOf('8') !== 0;

  /**
   * @returns {string} Billet's typeable line
   */
  formatLine = (): string => {
    const line = this.billet.typeableLine ?? this.billet.barcode;
    const formattedLine = line.replace(/\D/g, '');

    return formatBilletInput(formattedLine);
  };
}
